

import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
export const getSettingsWarehouseSetupCore = (isSuperAdmin = false) => {
    // Return different config objects based on isFulfilment
    return {
        general:  {
            title: 'general',
            icon: <AccountTreeOutlinedIcon />,
        },
        import:  {
            title: 'import',
            icon: <AccountTreeOutlinedIcon />,
        },
        // The invoicing configuration is superadmin (sha) only
        ...(isSuperAdmin ? {
            facturatie:  {
                title: 'invoicing',
                icon: <RequestQuoteOutlinedIcon />,
            },
        } : {}),
    };
};